//import {
//  HARD_MODE_DESCRIPTION,
//  HIGH_CONTRAST_MODE_DESCRIPTION,
//} from '../../constants/strings'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isDarkMode: boolean
  handleDarkMode: Function
  isHighContrastMode: boolean
  handleHighContrastMode: Function
}

export const SponsorModal = ({
  isOpen,
  handleClose,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
}: Props) => {
  // Generate a timestamp to append to the iframe URL for cache-busting
  const cacheBustedUrl = `/sponsor.html?timestamp=${new Date().getTime()}`;

  return (
    <BaseModal title="Featured Sponsor" isOpen={isOpen} handleClose={handleClose}>
      <div className="mt-2 flex flex-col divide-y" style={{ height: '70vh' }}>
        <iframe 
          src={cacheBustedUrl}
          title='featuredsponser'
          style={{ 
            width: '100%', 
            height: '100%', 
            border: 'none', 
            overflow: 'hidden' 
          }} 
        />
      </div>
    </BaseModal>
  );
}
